import { Component, OnInit } from '@angular/core';

import { RouterService } from 'app/00_modules/core/services/router.service';
import { StorageService } from 'app/00_modules/core/services/storage.service';
import { UserService } from 'app/00_modules/core/services/user.service';
import { Observable } from 'rxjs';
import { Role } from '../../core/user/Role';
import { UserFacade } from '../../../store/facade/user.facade';
import { FormsModule } from '@angular/forms';
import { JeListComponent } from '../../shared/components/inputs/list/list.component';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'je-userroleselection-container',
    standalone: true,
    templateUrl: './userroleselection.container.html',
    imports: [FormsModule, JeListComponent, TranslateModule, AsyncPipe],
})
export class UserRoleSelectionContainerComponent implements OnInit {
    public roles$: Observable<Role[]>;

    constructor(
        private userService: UserService,
        private storageService: StorageService,
        private router: RouterService,
        private userFacade: UserFacade
    ) {}

    public ngOnInit(): void {
        this.roles$ = this.userService.getUserRoles();
    }

    public onSelectionChanged(selectedItem: Object) {
        const role = selectedItem as Role;
        if (role === null) {
            return;
        }

        this.storageService.setRoleValues(role.id, role.name);
        this.userFacade.setUserRole(role);

        this.router.gotoHome();
    }
}
